import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { ButtonSuccessStyle } from '../styles'
import AcceptHealthClaimModal from '../../HealthClaimPage/AcceptHealthClaimModal'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'

export const AcceptClaimButton = () => {
  const { claimFormId } = useParams<{ claimFormId?: string }>()
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const getInsuredPersonName = () => {
    const firstName = healthClaim.data?.policyDetails?.[0]?.insuredFirstName || ''
    const lastName = healthClaim.data?.policyDetails?.[0]?.insuredLastName || ''
    return `${firstName} ${lastName}`.trim()
  }

  return (
    <>
      <ButtonSuccessStyle onClick={handleOpenModal}>รับเคส</ButtonSuccessStyle>
      <AcceptHealthClaimModal
        isModalOpen={isModalOpen}
        claimFormId={claimFormId || ''}
        claimNumber={healthClaim.data?.claimNumber || ''}
        insuredPersonName={getInsuredPersonName()}
        onClose={handleCloseModal}
        mode="confirmation"
      />
    </>
  )
}
